/* import __COLOCATED_TEMPLATE__ from './noise-table-column-header.hbs'; */
import Component from '@ember/component';

export default class NoiseTableColumnHeader extends Component {
    tagName = '';
}
